import { useCompetencyMatrix } from '@/api/reports';
import { LoadingSpinner } from '@/components/shared/loading-spinner';
import { ErrorMessage } from '@/components/shared/error-message';
import { EmptyState } from '@/components/shared/empty-state';
import { cn } from '@/lib/utils';
import { DECLARATION_BADGES } from '../_labels';

export function MatrixSection() {
  const { data, isLoading, error } = useCompetencyMatrix();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message="No se pudo cargar la matriz de competencia." />;
  if (!data?.length)
    return <EmptyState title="Sin datos" description="No hay datos en la matriz." />;

  return (
    <div className="space-y-6">
      {data.map((position) => (
        <div key={position.position_id} className="rounded-xl border border-border bg-card">
          {/* Position header */}
          <div className="border-b border-border px-5 py-4">
            <h3 className="text-sm font-semibold text-card-foreground">
              {position.position_name}
              {position.position_code && (
                <span className="ml-2 text-xs font-normal text-muted-foreground">
                  ({position.position_code})
                </span>
              )}
            </h3>
            <p className="text-xs text-muted-foreground">
              {position.department} — {position.company}
            </p>
          </div>

          {/* Users table */}
          {position.users.length === 0 ? (
            <div className="px-5 py-4 text-sm text-muted-foreground">
              Sin usuarios asignados a esta posición.
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="border-b border-border bg-muted/30">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium text-muted-foreground">
                      Usuario
                    </th>
                    <th className="px-4 py-2 text-left font-medium text-muted-foreground">Email</th>
                    <th className="px-4 py-2 text-left font-medium text-muted-foreground">
                      Declaracion
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border">
                  {position.users.map((user) => {
                    const badge = (DECLARATION_BADGES[user.declaration_status] ??
                      DECLARATION_BADGES.none)!;
                    const BadgeIcon = badge.icon;
                    return (
                      <tr key={user.user_id} className="hover:bg-muted/30">
                        <td className="px-4 py-3 text-card-foreground">
                          {user.user_name}
                          {!user.is_active && (
                            <span className="ml-1.5 text-xs text-muted-foreground">(inactivo)</span>
                          )}
                        </td>
                        <td className="px-4 py-3 text-muted-foreground">{user.email}</td>
                        <td className="px-4 py-3">
                          <span
                            className={cn(
                              'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
                              badge.color,
                            )}
                          >
                            <BadgeIcon className="h-3 w-3" />
                            {badge.label}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
